import React, { useEffect, useState, useMemo } from 'react';
import AppLayout from '../../components/layout/AppLayout';
import { useTranslation } from 'react-i18next';
import DashboardParent from './parent/DashboardParent';
import DashboardAnimateur from './animateur/DashboardAnimator';
import { useUserApi } from '../../api/user/userApp';
import { TDashboard } from '../../models/user/Dashboard';
import { message } from 'antd';

const Dashboard: React.FC = () => {
    const { t } = useTranslation();
    const { getDashboard } = useUserApi();

    const [dashboard, setDashboard] = useState<TDashboard | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        let isMounted = true;

        const fetchDashboard = async () => {
            try {
                const resp = await getDashboard();
                if (isMounted) {
                    setDashboard(resp.data);
                }
            } catch (err: any) {
                message.error(err.response?.data ?? err.message);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchDashboard();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line
    }, []);

    const contentView = useMemo(() => {
        if (dashboard?.dashboard_children?.length) {
            return <DashboardParent dashboard={dashboard} />;
        }
        return <DashboardAnimateur dashboard={dashboard} />;
    }, [dashboard]);

    return (
        <AppLayout title={t('sidebar.dashboard', 'Dashboard')} loading={loading}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 28,
                    padding: '4px 4px 16px',
                }}
            >
                {contentView}
            </div>
        </AppLayout>
    );
};

export default React.memo(Dashboard);
